import { CircularProgress, Paper } from "@mui/material";
import Breadcrumb from "../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../App/Components/PageContainer/PageContainer";
import GroupHeader from "./Components/GroupHeader";
import GroupTableTabs from "./Components/GroupTableTabs";
import { GroupCandidateSelectionProvider } from "./State/GroupCandidateSelectionContext";
import { GroupProfileProvider, useGroupProfileContext } from "./State/GroupProfileContext";

export function GroupProfile() {
  return (
    <GroupProfileProvider>
      <GroupProfileBody />
    </GroupProfileProvider>
  );
}

const GroupProfileBody = () => {
  const { group, isLoading } = useGroupProfileContext();
  return isLoading ? (
    <PageContainer>
      <Breadcrumb pageTitle="Loading..." />
      <Paper
        sx={{
          mt: { xs: 1, md: 2 },
          p: { xs: 2, lg: 4 },
          pt: { xs: 2, lg: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Paper>
    </PageContainer>
  ) : (
    <PageContainer>
      <GroupCandidateSelectionProvider groupId={group.id}>
        <Breadcrumb pageTitle={group.name} />
        <Paper sx={{ mt: { xs: 1, md: 4 }, p: { xs: 2, lg: 4 } }}>
          <GroupHeader />
        </Paper>
        <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 }, pt: { xs: 2, lg: 2 } }}>
          <GroupTableTabs />
        </Paper>
      </GroupCandidateSelectionProvider>
    </PageContainer>
  );
};
